import { render } from "./PriceCalculate.vue?vue&type=template&id=eedd65fa&scoped=true"
import script from "./PriceCalculate.vue?vue&type=script&lang=js"
export * from "./PriceCalculate.vue?vue&type=script&lang=js"

import "./PriceCalculate.vue?vue&type=style&index=0&id=eedd65fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eedd65fa"]])

export default __exports__